import React, {useEffect, useState} from 'react';

import {importRemote} from '@module-federation/utilities';
import {useDispatch} from 'react-redux';
import {Dispatch} from 'redux';

/**
 * Function to pass to MFEs to make it possible for them to send events to the host
 * this event will be dispatched as usual redux action
 * @param dispatch function to dispatch actions in redux
 * @param scope MFE scope
 * @param eventName event name - any string to define certain event
 * @param options object with event data and meta
 */
const sendEvent = (
    dispatch: Dispatch,
    scope: 'popups',
    eventName: string,
    options?: {data?: unknown; meta?: {[key: string]: unknown}},
    // eslint-disable-next-line max-params
) => {
    dispatch({
        type: `MFE_${scope}_${eventName}`,
        ...(options && 'data' in options ? {payload: options.data} : {}),
        ...(options && 'meta' in options ? {meta: options.meta} : {}),
    });
};

type PropsPopupType = {
    remoteAppInfo: {
        module: string;
        scope: 'popups';
        url: string;
    };
    props?: any;
};

/**
 * DynamicRemotePopup
 */
export const DynamicRemotePopup: React.FC<PropsPopupType> = ({props, remoteAppInfo}) => {
    const element = React.useRef<HTMLDivElement>(null);
    const [remoteModule, setRemoteModule] = useState<null | any>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        const load = async () => {
            setRemoteModule(await importRemote(remoteAppInfo));
        };
        if (!remoteModule) load();
    }, [remoteModule, remoteAppInfo]);

    React.useEffect(() => {
        if (element.current && remoteModule) {
            remoteModule.default(element.current, {
                ...props,
                sendEvent: sendEvent.bind(null, dispatch, remoteAppInfo.scope),
            });
        }
        return () => {
            const {current: div} = element;
            while (div && div.firstChild && div.removeChild(div.firstChild));
        };
    }, [remoteModule, props, remoteAppInfo.scope]);

    return <div ref={element} />;
};
